import React, { useCallback, useEffect } from "react";
import { Container, Row, Col, Spinner } from "reactstrap";
import { useParams, useLocation } from "react-router-dom";

import BreadCrumb from "Components/Common/BreadCrumb";
import PSEAAssessmentDetails from "../PSEAAssessmentDetails";
import { getPseaAssessment } from "common/services/psea-assessments.service";
import { normalize } from "common/lib/normalize";
import { usePageActivity } from "Components/Hooks/UsePageActivity";

const ViewPSEAAssessment = () => {
  const location = useLocation();
  const { id: itemId } = useParams();
  usePageActivity(location.pathname, "View PSEA Assessment", itemId);

  const [loading, setLoading] = React.useState<boolean>(false);
  const [data, setData] = React.useState<any>({});

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getPseaAssessment(itemId, {});
      setData(normalize(response.data));
    } catch (e) {
      // no-op
    } finally {
      setLoading(false);
    }
  }, [itemId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  document.title = "PSEA Assessment | CIMS";

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="PSEA Assessment Details"
          back
          pageTitles={[
            { title: "Dashboard", link: "/dashboard" },
            {
              title: "PSEA Assessments",
              link: "/assessments/psea-assessments",
            },
          ]}
        />

        {loading ? (
          <div className="text-center py-5">
            <Spinner color="primary" />
          </div>
        ) : (
          <Row>
            <Col lg={12}>
              <PSEAAssessmentDetails data={data} />
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
};

export default ViewPSEAAssessment;
